import { Modal, Radio, Tooltip, Icon } from 'antd';
import * as React from 'react';
import injectSheet from 'react-jss';
import { bindActionCreators } from 'redux';
import { setFilter, applyFilter } from '../../../../actions/inquiryFFActionBids';
import { connect } from 'react-redux';
import { InquiryModes } from 'src/Library/Constants';

const styles = (theme) => ({
  modal: {
    position: 'absolute',
    '& .ant-modal-body': {
      padding: '12px',
    },
    marginLeft: '53%',
    marginTop: '1%',
  },
});
class BidsSortByModal extends React.Component<any, any> {
  onChange = (e) => {
    this.props.setFilter({
      sortBy: e.target.value,
      descendingOrder: false,
    });
    this.props.handleCancel();
    this.props.applyFilter(this.props.id);
  };

  toggleOrder = () => {
    this.props.setFilter({
      descendingOrder: !this.props.filters.descendingOrder,
    });
  };

  handleOrder = (val) => {
    val === 'asc'
      ? this.props.setFilter({ descendingOrder: false })
      : this.props.setFilter({ descendingOrder: true });
    this.props.handleCancel();
    this.props.applyFilter(this.props.id);
  };

  renderOrderIcons() {
    const { appliedFilters } = this.props;
    return (
      <div style={{ display: 'flex', width: '20px', justifyContent: 'space-between' }}>
        <Tooltip placement="top" title="Ascending Order">
          <Icon
            type="caret-up"
            onClick={
              appliedFilters.descendingOrder === true ? () => this.handleOrder('asc') : undefined
            }
            style={{
              float: 'left',
              marginTop: '5px',
              height: '8px',
              width: '8px',
              color: `${appliedFilters.descendingOrder === true ? '#505050a6' : '#000000'}`,
            }}
          />
        </Tooltip>
        <Tooltip placement="top" title="Descending Order">
          <Icon
            type="caret-down"
            onClick={
              appliedFilters.descendingOrder === false ? () => this.handleOrder('desc') : undefined
            }
            style={{
              float: 'left',
              marginTop: '5px',
              height: '8px',
              width: '8px',
              color: `${appliedFilters.descendingOrder === true ? '#000000' : '#505050a6'}`,
            }}
          />
        </Tooltip>
      </div>
    );
  }

  render() {
    const { classes, visible, handleCancel, mode } = this.props;
    const option = [
      [InquiryModes.TRAILER].includes(mode)
        ? ['round_trip_time_hours', 'Round Trip Time']
        : ['transit_time', 'Transit Time'],
      ['total_charge', 'Total Charge'],
      ['rank', 'Rank'],
      ['updated_at', 'Updated At'],
    ];
    return (
      <Modal
        className={classes.modal}
        closable={false}
        visible={visible}
        onCancel={handleCancel}
        footer=""
        mask={false}
        width="220px"
      >
        <Radio.Group
          defaultValue={option?.[0]?.[0] || 'total_freight'}
          style={{ width: '100%' }}
          onChange={this.onChange}
          value={this.props.appliedFilters.sortBy}
        >
          {option.map((item) => {
            return (
              <div
                style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}
              >
                <div>
                  <Radio value={item[0]}>{item[1]}</Radio>
                </div>
                {this.props.appliedFilters.sortBy === item[0] ? this.renderOrderIcons() : null}
              </div>
            );
          })}
        </Radio.Group>
      </Modal>
    );
  }
}

const mapStateToProps = ({ inquiryFFBidsReducer }) => ({
  filters: inquiryFFBidsReducer.selectedFilters,
  appliedFilters: inquiryFFBidsReducer.appliedFilters,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setFilter,
      applyFilter,
    },
    dispatch
  );
export default injectSheet(styles)(connect(mapStateToProps, mapDispatchToProps)(BidsSortByModal));
